import { UI_SET_CURRENT_SECTION } from "../../action-types";

export const uiSetCurrentSection = (page) => ({
    type: UI_SET_CURRENT_SECTION,
    payload: page
});

